function StoryboardStepConfigurationPage() {
    /**
     *
     */
    StoryboardStepConfigurationPage.prototype.initialize = function (console, storyboard, storyboardStepIndex) {
        this.id = "storyboardStepConfiguration";
        this.console = console;
        this.storyboard = storyboard;
        this.storyboardStepIndex = storyboardStepIndex;

        return this;
    };

    /**
     *
     */
    StoryboardStepConfigurationPage.prototype.show = function () {
        var deferred = $.Deferred();

        if (this.storyboardStepIndex >= 0) {
            this.storyboardStep = this.console.consoleService.filterTransient(this.storyboard.content.timeline[this.storyboardStepIndex]);
            StoryboardStep.bind(this.storyboard, this.storyboardStep);
        }
        else {
            this.storyboardStep = StoryboardStep.create(this.storyboard);
        }

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    StoryboardStepConfigurationPage.prototype.openStoryboardStepEntryDialog = function (index) {
        if (index >= 0) {
            this.console.storyboardStepEntryDialog.storyboardStepEntry = this.console.consoleService.filterTransient(this.storyboardStep.entries[index]);

            StoryboardStepEntry.bind(this.storyboardStep, this.storyboardStep.entries[index]);

            this.console.storyboardStepEntryDialog.storyboardStepEntryIndex = index;
        }
        else {
            this.console.storyboardStepEntryDialog.storyboardStepEntry = StoryboardStepEntry.create(this.storyboardStep);
            this.console.storyboardStepEntryDialog.storyboardStepEntryIndex = -1;
        }

        this.console.Ui.turnOn("storyboardStepEntryDialog");
    };

    /**
     *
     */
    StoryboardStepConfigurationPage.prototype.createStoryboardStepEntry = function () {
        this.storyboardStep.entries.push(this.console.storyboardStepEntryDialog.storyboardStepEntry);

        this.closeStoryboardStepEntryDialog();
    };

    /**
     *
     */
    StoryboardStepConfigurationPage.prototype.updateStoryboardStepEntry = function (index) {
        this.storyboardStep.entries[this.console.storyboardStepEntryDialog.storyboardStepEntryIndex]
            = StoryboardStepEntry.bind(this.storyboardStep, this.console.storyboardStepEntryDialog.storyboardStepEntry);

        this.closeStoryboardStepEntryDialog();
    };

    /**
     *
     */
    StoryboardStepConfigurationPage.prototype.deleteStoryboardStepEntry = function (storyboardStepEntry) {
        this.console.openConfirmationDialog("You are going to delete a Storyboard Step Action. Please confirm.", function () {
            Utils.removeItemFromArray(this.storyboardStep.entries, storyboardStepEntry);
        }.bind(this));
    };

    /**
     *
     */
    StoryboardStepConfigurationPage.prototype.closeStoryboardStepEntryDialog = function () {
        this.console.Ui.turnOff("storyboardStepEntryDialog");
    };

    /**
     *
     */
    StoryboardStepConfigurationPage.prototype.createStoryboardStep = function () {
        this.storyboard.content.timeline.push(this.storyboardStep);

        this.console.popPage();
    };

    /**
     *
     */
    StoryboardStepConfigurationPage.prototype.updateStoryboardStep = function () {
        this.storyboard.content.timeline[this.storyboardStepIndex]
            = StoryboardStep.bind(this.storyboard, this.storyboardStep);
        this.console.popPage();
    };

    /**
     *
     */
    StoryboardStepConfigurationPage.prototype.leave = function () {
    };
}
